import { motion } from "framer-motion";
import { CHAPTERS } from "@/data/site";

export const Manifesto = () => {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="bg-brand-black text-white py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="text-xs font-bold uppercase tracking-[0.25em] text-brand-red mb-5">
            Chi siamo
          </div>
          <h2 className="font-heading font-bold text-4xl md:text-5xl tracking-tighter leading-[0.95] mb-8">
            Una realtà che accompagna <span className="text-brand-red">persone e aziende</span> nella sicurezza.
          </h2>
          <motion.div
            initial={{ clipPath: "inset(0% 0% 100% 0%)" }}
            whileInView={{ clipPath: "inset(0% 0% 0% 0%)" }}
            viewport={{ once: true }}
            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
            className="relative h-72 overflow-hidden"
          >
            <img
              src="/logo-treffe-bianco.webp"
              alt="Logo treffe — Formazione che crea esperienza"
              className="w-full h-full object-contain p-6 md:p-8"
            />
          </motion.div>
        </div>

        <div className="lg:col-span-6 lg:col-start-7 flex flex-col justify-center divide-y divide-white/10">
          {CHAPTERS.map((ch, i) => (
            <motion.div
              key={ch.num}
              data-testid={`chapter-${ch.num}`}
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="py-8 first:pt-0 group"
            >
              <div className="flex items-start gap-6">
                <span className="font-heading font-black text-5xl md:text-6xl stroke-text-red leading-none shrink-0">
                  {ch.num}
                </span>
                <div>
                  <h3 className="font-heading font-bold text-2xl mb-2 group-hover:text-brand-red transition-colors">
                    {ch.title}
                  </h3>
                  <p className="text-white/60 leading-relaxed text-sm md:text-base">
                    {ch.body}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
